import styled from 'styled-components';

const TicketIdButton = styled.div`
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;
  background-color: var(--accent-color-gray);
  border-left: 8px solid var(--grey200);
`;

export default TicketIdButton;
